import { render, staticRenderFns } from "./TeamViewDetail.vue?vue&type=template&id=bd665f9a&scoped=true&"
import script from "./TeamViewDetail.vue?vue&type=script&lang=js&"
export * from "./TeamViewDetail.vue?vue&type=script&lang=js&"
import style0 from "./TeamViewDetail.vue?vue&type=style&index=0&id=bd665f9a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd665f9a",
  null
  
)

export default component.exports